export class FactorgpiDialogData {
  contractId: number;
  clientId: number;
  factorId?: number;
  isExcluded: boolean;
}
